// DripItemFields.jsx
export default function DripItemFields({ drip }) {
 if (!drip) return null;

  const isEnrollment = drip.dripType === "ENROLLMENT_BASED";
  const isBatch = drip.dripType === "BATCH_BASED";

  const isHourWise = Number(drip.isHourWise) === 1;
  const isExactDate = Number(drip.isExactDate) === 1;

  return (
    <div style={{fontSize:"12px",margin:"5px"}}> 
      {/* ENROLLMENT BASED */}
      {isEnrollment && (
        <>
          {!isHourWise?<div>
            <strong> {drip.dripAfterDays?"Unlocks After":"" } {drip.dripAfterDays ?? "-"} {drip.dripAfterDays?"Days of Enrollment":""}.</strong> 
          </div>:

          (
            <div>
              <strong>{drip.dripAfterHours?"Unlocks After":"" } {drip.dripAfterHours ?? "-"} {drip.dripAfterHours?"Hours of Enrollment":""} .</strong> 
            </div>
          )}
        </>
      )}

      {/* BATCH BASED */}
      {isBatch && (
        <>
          {isExactDate ? (
            <div>
              <strong>{drip.dripAtDateTime?"Unlocks At ":"" } Exact Date Time :</strong>{" "}
              {drip.dripAtDateTime ?? "-"}  
            </div>
          ) : (
            <div>
              <strong>{drip.dripAtBatchOffsetDays?"Unlocks After":"" }  </strong>
              {drip.dripAtBatchOffsetDays ?? "-"} {drip.dripAtBatchOffsetDays?" Days From Batch Start.":"" } 
            </div>
          )}
        </>
      )}
    </div>
  );
}
